export default __webpack_public_path__ + "assets/fonts/cd7c5a734aeafd7321a12a4a4b95c45e.woff";